import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    incomeSources: [],
  },
  mutations: {
    setIncomeSources(state, incomeSources) {
      Vue.set(state, 'incomeSources', incomeSources);
    },
  },
  actions: {
    fetchIncomeSources ({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/income-sources`).then(response => {
        return commit('setIncomeSources', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};